import i18nTest from './i18n.test';
import i18nDev from './i18n.dev';
import i18nProd from './i18n.prod';

export default {
  test: i18nTest,
  production: i18nProd,
  development: i18nDev,
};
